import {
  Box,
  Stack,
  Text,
  IconEdit,
  Button,
  Bleed,
  Badge,
  useDialogController
} from '@machobear/design-system'
import { isEarlierThanCurrentMMYY } from '@/utils/check-expiry'
import { PaymentMethodType } from './types'
import EditPaymentModal from '../ds-edit-payment-modal'
import {
  VisaCard,
  AmericanExpressCard,
  MastercardCard,
  UnionPayCard,
  PlaceholderCard
} from '../icons'

type Props = {
  paymentMethod: PaymentMethodType
}

const HasPaymentMethodCard = ({ paymentMethod }: Props) => {
  const showExpiredWarnings = isEarlierThanCurrentMMYY(paymentMethod?.expiration_date)
  const {
    visible: isEditPaymentModalVisible,
    showModal: showEditPaymentModal,
    closeModal: closeEditPaymentModal
  } = useDialogController(false)

  const selectCardLogo = (type: string) => {
    switch (type) {
      case 'visa':
        return <VisaCard />
      case 'amex':
        return <AmericanExpressCard />
      case 'mastercard':
        return <MastercardCard />
      case 'unionpay':
        return <UnionPayCard />
      default:
        return <PlaceholderCard />
    }
  }

  const capitalizeFirstLetter = (inputString: string) =>
    inputString ? inputString[0].toUpperCase() + inputString.slice(1) : inputString

  return (
    <>
      <Box
        border="borderField"
        borderRadius="standard"
        padding="small"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="flexStart"
      >
        <Box display="flex" gap="small" alignItems="flexStart">
          {selectCardLogo(paymentMethod.brand)}
          <Stack space="small">
            <Box display="flex" gap="small" alignItems="center">
              <Text size="small" weight="strong">{`${capitalizeFirstLetter(
                paymentMethod.brand
              )} **** ${paymentMethod.card_number}`}</Text>
              {showExpiredWarnings && <Badge tone="critical"> Expired</Badge>}
            </Box>

            <Stack space="xxsmall">
              <Text
                size="small"
                tone="secondary"
              >{`${paymentMethod.first_name} ${paymentMethod.last_name}`}</Text>
              <Text size="small" tone="secondary">{`Expires ${paymentMethod.expiration_date.slice(
                0,
                2
              )}/${paymentMethod.expiration_date.slice(2)}`}</Text>
            </Stack>
          </Stack>
        </Box>

        <Bleed top="xxsmall">
          <Button
            variant="transparent"
            icon={<IconEdit />}
            size="small"
            onClick={showEditPaymentModal}
          >
            Edit
          </Button>
        </Bleed>
      </Box>
      <EditPaymentModal
        visible={isEditPaymentModalVisible}
        closeModal={closeEditPaymentModal}
        formInitialValues={paymentMethod}
      />
    </>
  )
}

export default HasPaymentMethodCard
